import moment from 'moment';

import type { NCalendars } from '@app/components/Calendars/types';

export const generateMonthWeeks = (
  date: NCalendars.MonthType
): NCalendars.MonthWeeks => {
  const startDate = moment(`${date.year}-${date.month}-01`, 'YYYY-MM-DD');
  const endDate = startDate.clone().endOf('month');
  const today = moment();
  const startCalendarDate = startDate.clone().startOf('week');
  const endCalendarDate = endDate.clone().endOf('week');
  const currentDay = startCalendarDate.clone();
  const weeks: NCalendars.MonthWeeks = [];

  while (currentDay.isBefore(endCalendarDate)) {
    const weekNumber = currentDay.week();
    const weekId = `${date.year}-${date.month}-${weekNumber}`;
    const week: NCalendars.WeekType = {
      id: weekId,
      days: [],
    };

    for (let i = 0; i < 7; i++) {
      const dayId = `${currentDay.year()}-${
        currentDay.month() + 1
      }-${currentDay.date()}`;
      week.days.push({
        id: dayId,
        day: currentDay.date(),
        isCurrentMonth: currentDay.month() + 1 === date.month,
        isToday: currentDay.isSame(today, 'day'),
        weekDayNumber: i + 1,
      });
      currentDay.add(1, 'day');
    }

    weeks.push(week);
  }

  return weeks;
};
